module.exports = __webpack_public_path__ + "img/logo.86497983.png";